import { render, staticRenderFns } from "./AppointmentNewStep.vue?vue&type=template&id=63b013e0&"
import script from "./AppointmentNewStep.vue?vue&type=script&lang=js&"
export * from "./AppointmentNewStep.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentNewStep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VApp,VBtn,VCard,VDialog,VIcon})
